<template>
  <hc-base-upload-readonly
    :hcCaseMasterId="hcCaseMasterId"
    :hcCaseFlightFileType="hcCaseFlightFileType"
    @downloadFile="downloadFile"
  ></hc-base-upload-readonly>
</template>

<script>
  import downloadService from "../../../services/downloadService";
  import FileTypeImage from "../../job/FileTypeImage";
  import handleRequestErrorMixin from "../../handleRequestErrorMixin";
  import HcBaseUploadReadonly from "./hc-base-upload-readonly";

  export default {
    name: "hc-ks-upload-readonly",
    mixins: [handleRequestErrorMixin],
    components: {HcBaseUploadReadonly, FileTypeImage},
    props: ["hcCaseMasterId", "hcCaseFlightFileType", "id"],

    data() {
      return {};
    },

    watch: {},

    created() {
    },

    methods: {
      downloadFile({hcCaseFlightFileId, vbAttachmentId}) {
        downloadService.downloadFileForHcCaseFlightFile(
          this.id,
          hcCaseFlightFileId,
          vbAttachmentId
        );
      }
    }
  };
</script>

<style scoped>
  .download-icon:hover {
    color: var(--color-blue) !important;
  }
</style>



// WEBPACK FOOTER //
// src/views/adminstration/khachsan/hc-ks-upload-readonly.vue